import { render, staticRenderFns } from "./DigitalProductLabel.vue?vue&type=template&id=39ce8304"
import script from "./DigitalProductLabel.vue?vue&type=script&lang=js"
export * from "./DigitalProductLabel.vue?vue&type=script&lang=js"
import style0 from "./DigitalProductLabel.vue?vue&type=style&index=0&id=39ce8304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports